import React, {MouseEvent, ReactElement, ReactNode, RefObject} from 'react';
import {ButtonBase, ButtonBaseProps, ButtonBaseTypeMap} from "@material-ui/core";

const styles = require('./openSiteButton.component.scss');

//TODO: this is a copy of KlButton. check if we can reuse it
//TODO: remove unused props
export type OpenSiteButtonProps<D extends React.ElementType = ButtonBaseTypeMap['defaultComponent'], P = Record<string, unknown>> = Omit<ButtonBaseProps<D, P>, 'ref'> & {
    buttonType?: 'primary' | 'secondary' | 'tertiary';
    size?: 'small' | 'medium' | 'large';
    isNegative?: boolean
    onClick?: (event?: MouseEvent<HTMLElement>) => void;
    text?: ReactNode;
    leftIcon?: ReactNode;
    rightIcon?: ReactNode;
    href?: string;
    round?: boolean;
    noPadding?: boolean;
    noBorder?: boolean;
    noHeight?: boolean;
    keepHeight?: boolean;
    square?: boolean;
    iconClassName?: string;
};

// eslint-disable-next-line max-len
function OpenSiteButtonRef<D extends React.ElementType = ButtonBaseTypeMap['defaultComponent'], P = Record<string, unknown>>(props: OpenSiteButtonProps<D, P>, ref: RefObject<HTMLButtonElement>) {
    const {buttonType, size, onClick, text, leftIcon, rightIcon, href, square, round, noPadding,
        noBorder, noHeight, keepHeight, className, iconClassName, isNegative, ...buttonBaseProps} = props;
    if (!text && !leftIcon && !rightIcon) return null;
    return (
        <ButtonBase
            className={`${styles.specific} ${styles.buttonContainer} ${size ? styles[size] : styles['medium']} ${buttonType ? styles[buttonType] : styles['primary']}
             ${round ? styles.round : ''} ${square ? styles.square : ''} ${noBorder ? styles.noBorder : ''} ${noPadding ? styles.noPadding : ''} ${keepHeight ? styles.keepHeight : ''}
             ${noHeight ? styles.noHeight : ''} ${!!isNegative ? styles.negative : styles.positive} ${className || ''}`}
            component={href ? "a" : undefined}
            {...buttonBaseProps}
            href={href}
            disableRipple={true}
            disableTouchRipple={true}
            onClick={onClick}
            ref={ref}
        >
            {leftIcon &&
                <span className={styles.iconContainer}>
                    {
                        typeof leftIcon === "string" ?
                            <i className={`${text ? styles.leftIcon : ''} ${leftIcon} ${iconClassName}`}/>
                            :
                            <div className={styles.leftIcon}>
                                {leftIcon}
                            </div>
                    }
                </span>}
            {text &&
                <span className={styles.buttonText}>
                    {text}
                </span>}
            {rightIcon &&
                <span className={styles.iconContainer}>
                    {
                        typeof rightIcon === 'string' ?
                            <i className={`${styles.rightIcon} ${rightIcon} ${iconClassName}`}/>
                            :
                            <div className={styles.rightIcon}>
                                {rightIcon}
                            </div>
                    }
                </span>}
        </ButtonBase>
    );
}

//Wondering wtf? Check out: https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref/58473012#comment106833751_58473012
export const OpenSiteButton = React.forwardRef(OpenSiteButtonRef) as <D extends React.ElementType = ButtonBaseTypeMap['defaultComponent'], P = Record<string, unknown>>(props: OpenSiteButtonProps<D, P> & { ref?: ButtonBaseProps<D, P>['ref'] }) => ReactElement | null;